import React from 'react';
import { ForgeIcon } from '@tylertech/forge-react';
import { EnvironmentFactory } from 'StorytellerEnvironment';
import { useDerivedReport } from './DerivedReportContext';
import { EditDerivedReportMetadata } from './EditDerivedReportMetadata/EditDerivedReportMetadata';

export function StoryBreadcrumbs() {
  const Environment = EnvironmentFactory();

  const { currentStory, canUpdate } = useDerivedReport();
  const defaultStory = Environment.RELATED_STORIES?.defaultStory;
  const currentViewIsDefault = currentStory.id == defaultStory?.id;

  return (
    <>
      <span className={currentViewIsDefault ? 'active-view' : 'inactive-view'}>{defaultStory?.name}</span>
      {!currentViewIsDefault && (
        <>
          <ForgeIcon className="breadcrumb-chev" name="chevron_right" />
          <span className="active-view">{currentStory.name}</span>
          {canUpdate && <EditDerivedReportMetadata />}
        </>
      )}
    </>
  );
}
